/**
 * 
 */

export const hasData = ({ data }) => !!data;
